import _asyncToGenerator from "/home/runner/work/design/design/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/design/design/node_modules/@babel/runtime/regenerator/index.js";
import fs from 'fs/promises';

/**
 * Parses a Figma node url and returns the file key and node id
 *
 * @param {string} url - Figma node url
 * @returns {object} - Object containing the file id and node id
 */
export function parseFigmaNodeUrl(nodeUrl) {
  var url = new URL(nodeUrl);
  var fileId = url.pathname.split('/')[2];
  var nodeId = url.searchParams.get('node-id');
  return {
    fileId: fileId,
    nodeId: nodeId
  };
}

/**
 * Slices an array into chunks of a given size
 *
 * @param {array} arr - Array to slice
 * @param {number} chunkSize - Size of the chunks
 * @returns {array} - Array of chunks
 */

export function sliceIntoChunks(arr, chunkSize) {
  var chunks = [];
  for (var i = 0; i < arr.length; i += chunkSize) {
    chunks.push(arr.slice(i, i + chunkSize));
  }
  return chunks;
}

/**
 * Ensures that a directory exists
 * @param {string} path - Path to the directory
 */

export function ensureDirectoryExists(_x) {
  return _ensureDirectoryExists.apply(this, arguments);
}

/**
 * Read JSON file from disk
 *
 * @param {string} path - Path to the JSON file
 *
 */
function _ensureDirectoryExists() {
  _ensureDirectoryExists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fs.access(path);
        case 3:
          _context.next = 16;
          break;
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
          if (!(_context.t0.code === 'ENOENT')) {
            _context.next = 16;
            break;
          }
          _context.prev = 8;
          _context.next = 11;
          return fs.mkdir(path, {
            recursive: true
          });
        case 11:
          _context.next = 16;
          break;
        case 13:
          _context.prev = 13;
          _context.t1 = _context["catch"](8);
          console.error("Failed to create directory ".concat(path, ": ").concat(_context.t1.message));
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 5], [8, 13]]);
  }));
  return _ensureDirectoryExists.apply(this, arguments);
}
export function readJsonFile(_x2) {
  return _readJsonFile.apply(this, arguments);
}
function _readJsonFile() {
  _readJsonFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path) {
    var data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return fs.readFile(path, 'utf8');
        case 3:
          data = _context2.sent;
          return _context2.abrupt("return", JSON.parse(data));
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](0);
          console.error("Failed to read JSON file ".concat(path, ": ").concat(_context2.t0.message));
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return _readJsonFile.apply(this, arguments);
}